@if (isMobile) {
    <p>
        <ap-icon-link [iconName]="icon()" link="tel:{{ phoneNumber() }}">{{ text() }}</ap-icon-link>
    </p>
}
@if (!isMobile) {
    <p class="ap-small phone-link__container">
        <asn-icon size="medium" color="secondary" [name]="icon()" class="phone-link__phone--icon"></asn-icon>{{ text() }}
    </p>
}
